import Menu from './Menu';

/**
 * @deprecated Use import from "@creditflowresearch/uilib/Menu" instead.
 */
export default Menu;
